import './yubinbango';

// npmのcocoon-jsを使うとafter-insertなどのイベントがなぜか発火しないため、
// アプリケーション内に直接置くことで回避している
import './cocoon';
